<template>
  <vjs-modal v-bind="$options.propsData"
             :title="title"
             icon="la la-clock-o"
             width="500">
    <template slot="body-content">
      <b-form class="update-publishing-modal-content" @submit.stop.prevent>
        <div class="row">
          <div class="col-6">
            <div class="form-group kt-form__group row">
              <label class="col-md-4 col-form-label">Published</label>
              <div class="col-md-2">
                <span class="kt-switch kt-switch--icon">
                  <label>
                    <input v-model="published" type="checkbox"
                           :checked="published"
                           name="published">
                    <span />
                  </label>
                </span>
              </div>
              <div class="col-12">
                <small>Publish schedules will override this value</small>
              </div>
            </div>
            <div class="m-form__group form-group">
              <div class="m-checkbox-list">
                <label class="m-checkbox">
                  <input v-model="schedule_publish_dates" type="checkbox"> Schedule Publish Dates
                  <span />
                </label>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div v-if="schedule_publish_dates" class="m-form__group form-group">
              <label for="js-publish_start">Publish From</label>
              <datetime id="js-publish_start"
                        v-model="publish_start"
                        input-class="form-control kt-input"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        :zone="timezone" />
            </div>
            <div v-if="schedule_publish_dates && ! never_unpublish" class="m-form__group form-group">
              <label for="js-publish_stop">Publish Until</label>
              <datetime id="js-publish_stop"
                        v-model="publish_stop"
                        input-class="form-control kt-input"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        :zone="timezone" />
            </div>

            <div v-if="schedule_publish_dates" class="form-group kt-form__group">
              <label class="ss-checkbox">
                <input v-model="never_unpublish" type="checkbox"> Never Unpublish
                <span />
              </label>
            </div>
          </div>
        </div>
      </b-form>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="() => close(true)">
        <loader v-if="waiting_callback" small class="mr-2" />
        Confirm
      </b-button>
      <b-button variant="ss-cancel" @click="() => close(false)">
        <loader v-if="waiting_callback" small class="mr-2" />
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import ItemPublishSettingsMixin from "VueMixins/ItemPublishSettingsMixin";
import { nullish } from 'Lib/type-sanity';

export default {
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin, ItemPublishSettingsMixin],
  asyncComputed: {
    feeds: {
      async get() {
        return (await axios.get('/api/v1/feeds')).data.data;
      },
      default: [],
    },
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Update Item Published Settings:',
    },
  },
  data: () => ({
    the_feed: null,
    timezone: window.user.timezone,
  }),
  methods: {
    nullish,
    close(confirmed) {
      this.close_data = {
        ...this.close_data,
        confirm: confirmed,
        publish_start: this.schedule_publish_dates ? this.publish_start : null,
        publish_stop: this.schedule_publish_dates ? this.publish_stop : null,
        published: this.published,
      };
      this.complete();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
